import React, { useState } from 'react';

import EnterPhoneNumberVerificationModal from '@/modules/user/components/Verification/PhoneVerificationModal/EnterPhoneNumberVerificationModal';
import PhoneVerificationCodeModal from '@/modules/user/components/Verification/PhoneVerificationModal/PhoneVerificationCodeModal';
import { PhoneVerificationStep } from '@/modules/user/components/Verification/verification.types';

import SuccessVerifiedModal from '../SuccessVerifiedModal';

interface Props {
  onSetVisible: (value: boolean) => void;
  employeePhoneNumber?: string;
  employerPhoneNumber?: string;
}

const PhoneVerificationModal: React.FC<Props> = ({ onSetVisible, employeePhoneNumber, employerPhoneNumber }) => {
  const [step, setStep] = useState(PhoneVerificationStep.ENTER_PHONE_NUMBER);
  const [phoneNumber, setPhoneNumber] = useState(employeePhoneNumber || employerPhoneNumber || '');

  return (
    <>
      {step === PhoneVerificationStep.ENTER_PHONE_NUMBER && (
        <EnterPhoneNumberVerificationModal
          phoneNumber={phoneNumber}
          onSetVisible={onSetVisible}
          setStep={setStep}
          setPhoneNumber={setPhoneNumber}
          employerPhoneNumber={employerPhoneNumber}
        />
      )}
      {step === PhoneVerificationStep.PHONE_VERIFICATION_CODE && (
        <PhoneVerificationCodeModal
          phoneNumber={phoneNumber}
          onSetVisible={onSetVisible}
          onBack={() => setStep(PhoneVerificationStep.ENTER_PHONE_NUMBER)}
          onNext={() => setStep(PhoneVerificationStep.PHONE_VERIFIED_SUCCESSFULLY)}
        />
      )}
      {step === PhoneVerificationStep.PHONE_VERIFIED_SUCCESSFULLY && (
        <SuccessVerifiedModal
          onSetVisible={onSetVisible}
          subTitle="You can update your phone number anytime in your Account Profile."
        />
      )}
    </>
  );
};

export default PhoneVerificationModal;
